export const MuiPopover = {
  styleOverrides: {
    root: {
      '.MuiMenu-paper.MuiPaper-root': {
        backgroundColor: '#FFF',
        '.MuiList-root': {
          maxHeight: '154px',
          height: 'auto',
          overflowY: 'auto',

          '&::-webkit-scrollbar': {
            width: '14px',
            height: '90%',
          },
          '&::-webkit-scrollbar-track': {
            width: '14px',
            background: '#F9F9F9',
            boxShadow: '1px 0px 0px 0px #DEDEDE inset',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#555',
            width: '11px',
            height: '54px',
            border: '4px solid transparent',
            borderRadius: '7px',
            backgroundClip: 'content-box',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: 'rgba(0, 0, 0, 0.60)',
            width: '11px',
            height: '54px',
            border: '4px solid transparent',
            borderRadius: '7px',
            backgroundClip: 'content-box',
          },
        },
      },

      '.MuiPickersPopper-paper.MuiPaper-root': {
        backgroundColor: '#FFF',
      },
    },
  },
}
